import React from 'react'
import type { BillOfMaterialsProviderProps } from './Context'
import { BillOfMaterialsProvider } from './Context'
import { BomDetails } from './BomDetails'
import { Col, Row, Stack } from 'react-bootstrap'
import { BomInventory } from './BomInventory'
import { BomSummary } from './BomSummary'

export const BillOfMaterials = (props: Omit<BillOfMaterialsProviderProps, 'children'>) => {
  return (
    <BillOfMaterialsProvider {...props}>
      <BillOfMaterialsLayout />
    </BillOfMaterialsProvider>
  )
}

export const BillOfMaterialsLayout = () => {
  return (
    <Stack gap={3}>
      <BomDetails />
      <Row className="">
        <Col md={7}>
          <h5>Summary</h5>
          <BomSummary />
        </Col>
        <Col md={5}>
          <h5>Inventory</h5>
          <BomInventory />
        </Col>
      </Row>
    </Stack>
  )
}
